<!--subscription-->
<div class="modal fade" id="subscription" data-bs-backdrop="static"
  aria-labelledby="exampleModalToggleLabel" tabindex="-1">
  <!-- <div class="modal-dialog modal-dialog-centered modal-xl"> -->
  <div [ngClass]="{'modal-dialog modal-dialog-centered': true, 'modal-xl': isExtraLarge}">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalToggleLabel">Subscription Plans</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="subscription_plan_section">
          <!-- <p>{{alertMessage}}</p> -->
          <p>This is the paid content please subscribe any plan to list your vehicle</p>
          <div class="boxes">
            <div class="row">
              @for (plan of planList; track plan) {
                <div [ngClass]="{'col-md-4': isExtraLarge, 'col-12': !isExtraLarge}"
                  >
                  <div class="new_plan_box">
                    <div class="top_section">
                      <h2>Plan name - {{plan.plan_name}}</h2>
                    </div>
                    <div class="new_plan_body">
                      @if (plan.price == '0') {
                        <h3>K{{plan.price}} <span class="free_tag">Free</span>
                      </h3>
                    }
                    @if (plan.price != '0') {
                      <h3>K{{plan.price}}</h3>
                    }
                    @if (plan.days == '1') {
                      <p>Plan Duration: <strong>{{plan.days}} Day</strong>
                    </p>
                  }
                  @if (plan.days != '1') {
                    <p>Plan Duration: <strong>{{plan.days}} Days</strong>
                  </p>
                }
                <p>Number of upload permission: <strong>{{plan.upload_permission}}</strong></p>
                <div class="form-check plan_check">
                  <input class="form-check-input" type="radio" name="flexRadioDefault"
                    [checked]="isPlanSelected(plan.planId)"
                    (change)="choosePlan(plan.planId,plan.price)" [id]="'plan-' + plan.planId">
                    <label class="form-check-label" [for]="'plan-' + plan.planId">Select {{plan.plan_name}}</label>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (showIssueSubscription) {
            <p style="color: red;">Select the plan name to proceed</p>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-center">
    @if (pricePlan == '') {
      <button class="btn view_all_but" (click)="openDetailsModal()">PAY</button>
    }
    @if (pricePlan != '') {
      <button class="btn view_all_but" (click)="openDetailsModal()">PAY
      K{{pricePlan}}</button>
    }
  </div>
</div>
</div>
</div>


<div class="modal fade" id="subscription2" data-bs-backdrop="static"
  aria-labelledby="exampleModalToggleLabel2" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content">
      <div class="modal-header pay_modal-header">
        <!-- <img *ngIf="userCountryName == 'Malawi'" src="../assets/images/mpamba.svg" alt="" />
        <h5 class="modal-title mt-2" *ngIf="userCountryName == 'Malawi'" id="exampleModalLabel">Pay via Mpamba</h5>
        <h5 class="modal-title mt-2" *ngIf="userCountryName != 'Malawi'" id="exampleModalLabel">Pay</h5> -->
        <!-- <p><strong>Transaction ID :</strong> #{{planDetails?.transactionId}}</p> -->
        <h5 class="modal-title" id="exampleModalLabel">Plan</h5>

        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="pay_modal_body">
          <!-- <p>Billig details</p>
          <p *ngIf="planDetails?.user_type != 'private'">
            <strong>Plan Name :</strong> {{planDetails?.plan_name}}
          </p>
          <p *ngIf="planDetails?.price == '0' && planDetails?.user_type != 'private'">
            <strong>Price :</strong>  K{{planDetails?.price}} (Free)
          </p>
          <p *ngIf="planDetails?.price != '0' && planDetails?.user_type != 'private'">
            <strong>Price :</strong>  K{{planDetails?.price}}
          </p>
          <p *ngIf="planDetails?.days != '1' && planDetails?.user_type != 'private'">
            <strong>Plan Duration :</strong> {{planDetails?.days}} Days
          </p>
          <p *ngIf="planDetails?.days == '1' && planDetails?.user_type != 'private'">
            <strong>Plan Duration :</strong> {{planDetails?.days}} Day
          </p>
          <p *ngIf="planDetails?.user_type != 'private'">
            <strong>Upload permission :</strong> {{planDetails?.upload_permission}}
          </p>

          <p *ngIf="planDetails?.user_type == 'private'">
            <strong style="color: red;">K{{planDetails?.price}}</strong>
          </p>
          <p *ngIf="planDetails?.days != '1' && planDetails?.user_type == 'private'">
            For: <strong style="color: red;">{{planDetails?.days}} Days</strong>
          </p>
          <p *ngIf="planDetails?.days == '1' && planDetails?.user_type == 'private'">
            For: <strong style="color: red;">{{planDetails?.days}} Day</strong>
          </p> -->

          <!-- <h3 *ngIf="pricePlan != '0' && userCountryName == 'Malawi'">Pay</h3> -->

          <!-- <strong>Payment mode</strong>
          <input type="radio" id="paychangu" name="payment" value="TNM MPAMBA" checked>
          <label for="paychangu">TNM MPAMBA</label> -->
          <p>This is the paid content. <br />Please purchase the plan to list your vehicle.</p>

          <div class="pay_modal_card">
            <h2>K{{planDetails?.price}}</h2>
            <p>Plan Duration: {{planDetails?.days}} Days</p>
            @if (userType == 'private') {
              <span class="tag">Private</span>
            }
            @if (userType != 'private') {
              <span class="tag">Business</span>
            }
          </div>
        </div>

      </div>
      <div class="modal-footer justify-content-center">
        <button class="btn view_all_but" (click)="submitPlanRequest()" data-bs-dismiss="modal">Proceed to
        pay</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="subscription_new" data-bs-backdrop="static"
  aria-labelledby="exampleModalToggleLabel2" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content">
      <div class="modal-header pay_modal-header">
        <h5 class="modal-title">Successful</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center">
        <img src="../assets/images/payment_success.svg" alt="Payment successful" class="payment_success" />
      </div>
      <div class="modal-footer  justify-content-center border-0">
        <button type="submit" class="btn view_all_but" data-bs-dismiss="modal">Done</button>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="subscription_failed" data-bs-backdrop="static"
  aria-labelledby="exampleModalToggleLabel2" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content">
      <div class="modal-header pay_modal-header">
        <h5 class="modal-title">Failed</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center">
        <img src="../assets/images/failed.svg" alt="Payment failed" class="payment_success" />
        <p>Payment failed</p>
      </div>
      <div class="modal-footer  justify-content-center border-0">
        <button type="submit" class="btn view_all_but" data-bs-dismiss="modal">Done</button>
      </div>
    </div>
  </div>
</div>

<div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="offcanvasExampleLabel"><a href="/" [routerLink]="roleId ? '/users/dashboard' : '/'"
    (click)="indexDashboard()"><img class="mobile_logo" src="assets/images/logo.png" alt="Kawawa Motors" width="205" height="53" /></a></h5>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close mobile menu"></button>
  </div>
  <div class="offcanvas-body">
    @if (countryFlagUrl.length>0) {
      <div class="country_flag_area">
        <div class="inside" (click)="change()" role="button" aria-label="Change country">
          <img src="{{countryFlagUrl}}" alt="{{countryName}} flag" />
          <p>{{countryName}}</p>
        </div>
        @if (showDropdown == true) {
          <div class="country_drop" data-bs-dismiss="offcanvas">
            @for (countries of itemCountries; track countries) {
              <div>
                <div class="country_img_text"
                  (click)="changeCountry(countries.countryId,countries.countryName,countries.countryFlagUrl)">
                  <p><img src="{{countries.countryFlagUrl}}" alt="{{countries.countryName}} flag" style="width:20px;height: 10px;" /> &nbsp;{{countries.countryName}}</p>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }

    <div class="mobile_country_and_chat" data-bs-dismiss="offcanvas" data-bs-target="#offcanvasExample"
      aria-controls="offcanvasExample">
      <div class="top_header_right">
        <div class="enquiry_area" (click)="liveChat()" role="button" aria-label="Open live chat">
          @if (roleId!= '') {
            <div>
              <i class="fas fa-comment-alt"></i>
              @if (unreadMessages!= 0) {
                <p class="alart">{{unreadMessages}}</p>
              }
            </div>
          }
        </div>

        <div (click)="broadcastes()" class="broadcasts_area" role="button" aria-label="View broadcasts">
          @if (roleId!= '') {
            <div>
              <i class="fa-solid fa-bullhorn"></i>
              <!-- <div *ngIf="broadcasts == 0"></div> -->
              @if (broadcasts!= 0) {
                <p class="alart">{{broadcasts}}</p>
              }
            </div>
          }
        </div>

        @if (roleId!= '') {
          <a href="/home/my-notifications" routerLink="/home/my-notifications" (click)="myNotifications()" class="notification_area">
            <div>
              <i class="fa-solid fa-bell"></i>
              @if (bellIconNotification!= 0) {
                <p class="alart">{{bellIconNotification}}</p>
              }
            </div>
          </a>
        }
        <div class="enquiry_area" (click)="myEnquiries()" role="button" aria-label="View my enquiries">
          @if (roleId!= '') {
            <div>
              <i class="fa-solid fa-circle-exclamation"></i>
              @if (enquiries!= 0) {
                <p class="alart">{{enquiries}}</p>
              }
            </div>
          }
        </div>
      </div>
    </div>

    <div class="mobile_profile" data-bs-dismiss="offcanvas" data-bs-target="#offcanvasExample"
      aria-controls="offcanvasExample">
      @if (roleId== '') {
        <div>
          <a href="/users/login" routerLink="/users/login" (click)="login()" class="profile_area" aria-label="Login or Register">
            <img src="assets/images/profile_icon.svg" alt="User profile icon" />
            <div>
              <p>Login/Register </p>
            </div>
          </a>
        </div>
      }
      @if (roleId!= '') {
        <div>
          <a [href]="roleId == '0a7f492c-3322-4a0a-af41-85ce8d551d28' ? '/users/edit-business-account' : '/users/edit-private-account'" [routerLink]="roleId == '0a7f492c-3322-4a0a-af41-85ce8d551d28' ? '/users/edit-business-account' : '/users/edit-private-account'" (click)="profile()" class="profile_area">
            <!-- <img *ngIf="imageStatus== 0" [src]="iseditImageUrl" alt=""  /> -->
            @if (roleId== 'd1b4a3ce-cfb5-420c-98cd-901ce5ab88cd') {
              <div>@if (imgURL != '') {
                <img
                  [src]="imgURL" alt="Profile photo" />
                }@if (imgURL == '') {
                <span class="profileNameColor"
                  [style.color]="UserNameColor" [style.border]="borderColor"
                [style.background]="BackgroundColor">{{nameImage}}{{lastNameTrimmed}}</span>
              }</div>
            }
            @if (roleId== '0a7f492c-3322-4a0a-af41-85ce8d551d28') {
              <div>@if (imgBusinessURL != '') {
                <img
                  [src]="imgBusinessURL" alt="Business logo" />
                }@if (imgBusinessURL == '') {
                <span class="profileNameColor"
                  [style.color]="UserNameColor" [style.border]="borderColor"
                [style.background]="BackgroundColor">{{nameImage}}{{lastNameTrimmed}}</span>
              }</div>
            }
            @if (roleId== 'd1b4a3ce-cfb5-420c-98cd-901ce5ab88cd') {
              <div>
                <p>{{aboutMe.fullName}}</p>
              </div>
            }
            @if (roleId== '0a7f492c-3322-4a0a-af41-85ce8d551d28') {
              <div>
                <p>{{aboutMe.businessAccount.businessName}}</p>
              </div>
            }
          </a>
        </div>
      }
    </div>

    <a href="/users/search" routerLink="/users/search" (click)="search()" class="search_area" data-bs-dismiss="offcanvas"
      data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
      <p>Search Vehicles, Parts, Garages, Dealers</p>
      <p><i class="fas fa-search"></i></p>
    </a>

    <ul class="nav-menu" data-bs-dismiss="offcanvas" data-bs-target="#offcanvasExample"
      aria-controls="offcanvasExample">
      @if (roleId == '') {
        <li [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="menu-active"><a href="/" routerLink="/"
        (click)="home()">Home</a></li>
      }

      @if (roleId != '') {
        <li [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="menu-active"><a
        href="/users/dashboard" routerLink="/users/dashboard" (click)="home()">Home</a></li>
      }

      <li routerLinkActive="menu-active"><a href="/home/about-us" routerLink="/home/about-us"
      (click)="aboutUs()">About Us</a></li>

      <li routerLinkActive="menu-active"><a href="/home/contact-us" routerLink="/home/contact-us"
      (click)="contactUs()">Contact Us</a></li>

      <li routerLinkActive="menu-active"><a href="/blog" routerLink="/blog">Blog</a></li>

      <!-- <li *ngIf="userType != 'private'"><a href="javascript:void(0)" (click)="fetchPlanList()">Subscription</a>
    </li> -->

    <li [routerLinkActiveOptions]="{exact: false}"
      routerLinkActive="menu-active"><a href="/services/service-list" routerLink="/services/service-list" (click)="services()">Services</a>
      <div routerLink="/vehicle-all-list"></div>
      <div routerLink="/rental-vehicle-all-list"></div>
      <div routerLink="/repair-garage-all-list"></div>
      <div routerLink="/sparepart-all-list"></div>
      <div routerLink="/dealers-all-list"></div>
      <div routerLink="details/vehicle-details"></div>
      <div routerLink="details/rental-vehicle-details"></div>
      <div routerLink="details/repair-garage-details"></div>
      <div routerLink="details/spareparts-details"></div>
      <div routerLink="details/delears-details"></div>
    </li>

  </ul>

  <div class="mt-4 list_your_items" data-bs-dismiss="offcanvas" data-bs-target="#offcanvasExample"
    aria-controls="offcanvasExample">
    <a href="/sell-items/sell-items-listing" routerLink="/sell-items/sell-items-listing" (click)="sellItemsListing()" class="list_item">+ List Your Items </a>
  </div>
</div>
</div>



<!-- Top Trigger Section -->
<div class="top-trigger-bar">
  <div class="scrolling-text-container">
    <div class="scrolling-text">
      <!-- First Set -->
      <span class="scrolling-item"><i class="fa-solid fa-car"></i> MALAWI'S NO.1 VEHICLE MARKETPLACE</span>
      <span class="separator-line"></span>
      <span class="scrolling-item"><i class="fa-solid fa-tags"></i> FIND THE BEST DEALS ON CARS & PARTS</span>
      <span class="separator-line"></span>
      <span class="scrolling-item"><i class="fa-solid fa-bullhorn"></i> LIST YOUR ITEMS FOR THOUSANDS OF BUYERS</span>
      <span class="separator-line"></span>
      <span class="scrolling-item"><i class="fa-solid fa-shield-halved"></i> 100% SAFE & SECURE TRANSACTIONS</span>
      <span class="separator-line"></span>
      <span class="scrolling-item"><i class="fa-solid fa-headset"></i> 24/7 CUSTOMER SUPPORT</span>
      <span class="separator-line"></span>

      <!-- Duplicate Set for Seamless Loop -->
      <span class="scrolling-item"><i class="fa-solid fa-car"></i> MALAWI'S NO.1 VEHICLE MARKETPLACE</span>
      <span class="separator-line"></span>
      <span class="scrolling-item"><i class="fa-solid fa-tags"></i> FIND THE BEST DEALS ON CARS & PARTS</span>
      <span class="separator-line"></span>
      <span class="scrolling-item"><i class="fa-solid fa-bullhorn"></i> LIST YOUR ITEMS FOR THOUSANDS OF BUYERS</span>
      <span class="separator-line"></span>
      <span class="scrolling-item"><i class="fa-solid fa-shield-halved"></i> 100% SAFE & SECURE TRANSACTIONS</span>
      <span class="separator-line"></span>
      <span class="scrolling-item"><i class="fa-solid fa-headset"></i> 24/7 CUSTOMER SUPPORT</span>
      <span class="separator-line"></span>
    </div>
  </div>
</div>

<section class="top_header">
  <div class="container">
    <div class="top_header_inner">
      <div class="logo_area">
        <a href="/" [routerLink]="roleId ? '/users/dashboard' : '/'" (click)="indexDashboard()"><img src="assets/images/logo.png" alt="Kawawa Motors" width="205" height="53" /></a>
      </div>

      <button class="mobile_menu" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample"
        aria-controls="offcanvasExample" aria-label="Open navigation menu">
        <i class="fas fa-bars" aria-hidden="true"></i>
      </button>

      <!-- <div class="country_flag_area" *ngIf="roleId!= ''">
      <img src="{{countryFlagUrl}}" alt="" />
      <p>{{aboutMe?.country?.countryName}}</p>
    </div> -->

    @if (countryFlagUrl.length>0) {
      <div class="country_flag_area">
        <div class="inside" (click)="change()" role="button" aria-label="Change country">
          <img src="{{countryFlagUrl}}" alt="{{countryName}} flag" (click)="change()" />
          <p (click)="change()">{{countryName}}</p>
        </div>
        @if (showDropdown == true) {
          <div>
            @if (showDropdown == true) {
              <div class="country_drop">
                @for (countries of itemCountries; track countries) {
                  <div>
                    <div class="country_img_text"
                      (click)="changeCountry(countries.countryId,countries.countryName,countries.countryFlagUrl)">
                      <p><img src="{{countries.countryFlagUrl}}" alt="{{countries.countryName}} flag" style="width:20px;height: 10px;" /> &nbsp;
                      {{countries.countryName}}</p>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }

    <a (click)="closeDropdown()" href="/users/search" routerLink="/users/search" (click)="search()" class="search_area">
      <p>Search Vehicles, Parts, Garages, Dealers</p>
      <p><i class="fas fa-search"></i></p>
    </a>



    <div class="top_header_right">

      <div class="enquiry_area" (click)="liveChat()" role="button" aria-label="Open live chat">
        @if (roleId!= '') {
          <div>
            <i class="fas fa-comment-alt"></i>
            @if (unreadMessages!= 0) {
              <p class="alart">{{unreadMessages}}</p>
            }
          </div>
        }
      </div>

      <div (click)="broadcastes()" class="broadcasts_area" role="button" aria-label="View broadcasts">
        @if (roleId!= '') {
          <div>
            <i class="fa-solid fa-bullhorn"></i>
            <!-- <div *ngIf="broadcasts == 0"></div> -->
            @if (broadcasts!= 0) {
              <p class="alart">{{broadcasts}}</p>
            }
          </div>
        }
      </div>

      @if (roleId!= '') {
        <a href="/home/my-notifications" routerLink="/home/my-notifications" (click)="myNotifications()" class="notification_area">
          <div>
            @if (roleId!= '') {
              <div>
                <i class="fa-solid fa-bell"></i>
                @if (bellIconNotification!= 0) {
                  <p class="alart">{{bellIconNotification}}</p>
                }
              </div>
            }
          </div>
        </a>
      }
      <div class="enquiry_area" (click)="myEnquiries()" role="button" aria-label="View my enquiries">
        @if (roleId!= '') {
          <div>
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (enquiries!= 0) {
              <p class="alart">{{enquiries}}</p>
            }
          </div>
        }
      </div>

      @if (roleId== '') {
        <div>
          <a href="/users/login" routerLink="/users/login" (click)="login()" class="profile_area" aria-label="Login or Register">
            <img src="assets/images/profile_icon.svg" alt="User profile icon" />
            <div>
              <p>Login/Register </p>
            </div>
          </a>
        </div>
      }
      @if (roleId!= '') {
        <div>
          <a [href]="roleId == '0a7f492c-3322-4a0a-af41-85ce8d551d28' ? '/users/edit-business-account' : '/users/edit-private-account'" [routerLink]="roleId == '0a7f492c-3322-4a0a-af41-85ce8d551d28' ? '/users/edit-business-account' : '/users/edit-private-account'" (click)="profile()" class="profile_area">
            <!-- <img *ngIf="imageStatus== 0" [src]="iseditImageUrl" alt=""  /> -->
            @if (roleId== 'd1b4a3ce-cfb5-420c-98cd-901ce5ab88cd') {
              <div>@if (imgURL != '') {
                <img
                  [src]="imgURL" alt="Profile photo" />
                }@if (imgURL == '') {
                <span class="profileNameColor"
                  [style.color]="aboutMe.userColor.UserNameColor" [style.border]="borderColor"
                [style.background]="aboutMe.userColor.Background">{{nameImage}}{{lastNameTrimmed}}</span>
              }
            </div>
          }
          @if (roleId== '0a7f492c-3322-4a0a-af41-85ce8d551d28') {
            <div>@if (imgBusinessURL != '') {
              <img
                [src]="imgBusinessURL" alt="Business logo" />
              }@if (imgBusinessURL == '') {
              <span class="profileNameColor"
                [style.color]="aboutMe.userColor.UserNameColor" [style.border]="borderColor"
              [style.background]="aboutMe.userColor.Background">{{nameImage}}{{lastNameTrimmed}}</span>
            }
          </div>
        }
        @if (roleId== 'd1b4a3ce-cfb5-420c-98cd-901ce5ab88cd') {
          <div>
            <p>{{aboutMe.fullName}}</p>
          </div>
        }
        @if (roleId== '0a7f492c-3322-4a0a-af41-85ce8d551d28') {
          <div>
            <p>{{aboutMe.businessAccount.businessName}}</p>
          </div>
        }
      </a>
    </div>
  }
</div>
</div>
</div>
</section>

<section class="menu_section">
  <div class="container">
    <div class="menu_section_inside">
      <div class="top_header_menu_area">
        <nav id="nav-menu-container" aria-label="Main navigation">
          <ul class="nav-menu">

            @if (roleId == '') {
              <li [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="menu-active"><a href="/"
              routerLink="/" (click)="home()">Home</a></li>
            }

            @if (roleId != '') {
              <li [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="menu-active"><a href="/users/dashboard"
              routerLink="/users/dashboard" (click)="home()">Home</a></li>
            }

            <li routerLinkActive="menu-active"><a href="/home/about-us" routerLink="/home/about-us"
            (click)="aboutUs()">About Us</a></li>


            <li routerLinkActive="menu-active"><a href="/home/contact-us" routerLink="/home/contact-us"
            (click)="contactUs()">Contact Us</a></li>

            <li routerLinkActive="menu-active"><a href="/blog" routerLink="/blog">Blog</a></li>

            <!-- <li style="cursor: pointer;" *ngIf="userType != 'private'"><a
          (click)="fetchPlanList()">Subscription</a></li> -->

          <li [routerLinkActiveOptions]="{exact: false}"
            routerLinkActive="menu-active"><a href="/services/service-list" routerLink="/services/service-list"
          (click)="services()">Services</a>
          <div routerLink="/vehicle-all-list"></div>
          <div routerLink="/rental-vehicle-all-list"></div>
          <div routerLink="/repair-garage-all-list"></div>
          <div routerLink="/sparepart-all-list"></div>
          <div routerLink="/dealers-all-list"></div>
          <div routerLink="details/vehicle-details"></div>
          <div routerLink="details/rental-vehicle-details"></div>
          <div routerLink="details/repair-garage-details"></div>
          <div routerLink="details/spareparts-details"></div>
          <div routerLink="details/delears-details"></div>
        </li>

      </ul>
    </nav>

  </div>
  <div>
    <a href="/sell-items/sell-items-listing" routerLink="/sell-items/sell-items-listing" (click)="sellItemsListing()" class="list_item">+ List Your Items </a>
  </div>
</div>
</div>
</section>

<ngx-spinner type="pacman" bdColor="rgba(255,255,255,.8" template="<img src='assets/images/loader.gif' alt='loader' />">
</ngx-spinner>

<main id="main-content" role="main">
  <router-outlet></router-outlet>
</main>
@if (footerShow == true) {
  <footer>
    <div class="top_footer_section">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-sm-6 box1">
            <h2>Quick Links</h2>
            <ul>
              <li><a href="/" [routerLink]="roleId ? '/users/dashboard' : '/'" (click)="home()">Home</a></li>
              <li><a href="/home/about-us" routerLink="/home/about-us" (click)="aboutUs()">About Us</a></li>
              <li><a href="/services/service-list" routerLink="/services/service-list" (click)="services()">Services</a></li>
              <li><a target="_blank" href="/home/privacy-policy" [routerLink]="['/home/privacy-policy']">Privacy Policy</a></li>
              <li><a target="_blank" href="/home/terms-conditions" [routerLink]="['/home/terms-conditions']">Terms & Conditions</a></li>
              <li><a href="/blog" [routerLink]="['/blog']">Blog</a></li>
            </ul>
          </div>
          <div class="col-lg-3 col-sm-6 box1">
            <h2>Services</h2>
            <ul>
              <li><a href="/vehicle-all-list" routerLink="/vehicle-all-list" (click)="vehicleAllList()">Vehicles</a></li>
              <li><a href="/sparepart-all-list" routerLink="/sparepart-all-list" (click)="sparepartAllList()">Spare Parts</a></li>
              <li><a href="/repair-garage-all-list" routerLink="/repair-garage-all-list" (click)="repairGarageAllList()">Repair Garages</a></li>
              <!-- <li><a href="javascript:void(0)" (click)="rentalVehicleAllList()">Rent a Car</a></li> -->
              <li><a href="/dealers-all-list" routerLink="/dealers-all-list" (click)="dealersAllList()">Dealers</a></li>
            </ul>
          </div>
          <div class="col-lg-3 col-sm-6 box1">
            <h2>Help & Support</h2>
            <ul>
              <li><a href="/home/my-enquiries" routerLink="/home/my-enquiries" (click)="myEnquiries()">My Enquiries</a></li>
              <!-- <li><a href="javascript:void(0)" (click)="getInTouch()">Get in Touch</a></li> -->
              <li><a href="/home/contact-us" routerLink="/home/contact-us" (click)="contactUs()">Contact Us</a></li>
              <li><a href="/users/live-chat" routerLink="/users/live-chat" (click)="liveChat()">Live Chat</a></li>
              <!-- <li><a href="#">Invite Friends</a></li> -->
            </ul>
          </div>
          <div class="col-lg-3 col-sm-6 box1">
            <h2>Contact Us</h2>
            <!-- <p class="phone"><i class="fa-solid fa-phone"></i> <i class="fa-brands fa-whatsapp"></i>
          {{contact_us_admin_details?.phoneCountryCode}} {{contact_us_admin_details?.phoneNumber}}</p> -->
          <p class="phone"><i class="fa-solid fa-envelope"></i> {{contact_us_admin_details?.emailAddress}}</p>
          <p class="phone"><i class="fa-solid fa-clock"></i> Mon - Fri - 9am till 6pm</p>
          <!-- <p class="mt-2"><a href="#"><i class="fab fa-facebook-square"></i></a> <a href="#"><i
        class="fab fa-instagram"></i></a> <a href="#"><i
      class="fab fa-twitter-square"></i></a> <a href="#"><i
    class="fab fa-youtube"></i></a></p> -->
    <!-- <p class="mt-2"><a target="_blank" rel="noopener noreferrer"
      href="https://play.google.com/store/apps/details?id=com.aprodence.kawawamotors"><img
    src="assets/images/Play_Store.svg" alt="" /></a></p> --s>
    <!-- <a href="#"><img src="assets/images/App_Store.svg" alt="" /></a> -->
    <div class="social-icons">
      <a href="https://www.facebook.com/profile.php?id=100024476305768" target="_blank" rel="noopener noreferrer" aria-label="Kawawa Motors on Facebook"><i
      class="fab fa-facebook-f" aria-hidden="true"></i></a>
      <!-- <a href="https://twitter.com/" target="_blank"><i class="fab fa-twitter"></i></a>
      <a href="https://www.linkedin.com/" target="_blank"><i class="fab fa-linkedin-in"></i></a> -->
      <a href="https://www.instagram.com/kawawamotors/" target="_blank" rel="noopener noreferrer" aria-label="Kawawa Motors on Instagram"><i
      class="fab fa-instagram" aria-hidden="true"></i></a>
    </div>
  </div>
</div>
</div>
</div>
<div class="bottom_footer_section">
  <div class="container">
    <p>
      Copyright © {{ currentYear }} Kawawa Motors • All Rights Reserved
    </p>
  </div>
</div>
</footer>
}